import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-data-form',
  templateUrl: './global-data-form.component.html',
  styleUrls: ['./global-data-form.component.css']
})
export class GlobalDataFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/global-data/global-data-form/global-data-form.component.ts